<template>
  <el-dialog
    :title="isEdit ? '编辑文章' : '新增文章'"
    :visible="visible"
    @close="$emit('update:visible', false)"
    width="80%"
    :close-on-click-modal="false"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="文章标题" prop="title">
            <el-input v-model="form.title" placeholder="请输入文章标题" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="文章分类" prop="category">
            <el-select v-model="form.category" placeholder="请选择分类" style="width: 100%">
              <el-option label="电梯知识" value="电梯知识" />
              <el-option label="太阳能资讯" value="太阳能资讯" />
              <el-option label="行业动态" value="行业动态" />
              <el-option label="公司新闻" value="公司新闻" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="文章标签">
            <el-input v-model="form.tags" placeholder="请输入标签，多个标签用逗号分隔" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发布状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
              <el-option label="草稿" value="draft" />
              <el-option label="已发布" value="published" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item label="封面图片">
        <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :headers="uploadHeaders"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeUpload"
          :show-file-list="false"
          accept="image/*"
        >
          <div v-if="form.cover" class="image-preview">
            <img :src="getImageUrl(form.cover)" alt="封面图片" />
            <div class="image-overlay">
              <el-button size="small" type="primary">更换图片</el-button>
              <el-button size="small" type="danger" @click.stop="removeCover">删除</el-button>
            </div>
          </div>
          <el-button v-else size="small" type="primary" icon="el-icon-upload">上传封面图片</el-button>
        </el-upload>
        <div class="upload-tip">支持 jpg、png、gif、webp 格式，文件大小不超过 16MB</div>
      </el-form-item>
      
      <el-form-item label="文章摘要">
        <el-input
          v-model="form.brief"
          type="textarea"
          :rows="3"
          placeholder="请输入文章摘要"
        />
      </el-form-item>
      
      <el-form-item label="文章内容" prop="content">
        <el-input
          v-model="form.content"
          type="textarea"
          :rows="10"
          placeholder="请输入文章内容"
        />
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="submitting">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ArticleForm',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      submitting: false,
      uploading: false,
      form: {
        title: '',
        content: '',
        category: '',
        tags: '',
        cover: '',
        brief: '',
        status: 'draft'
      },
      rules: {
        title: [{ required: true, message: '请输入文章标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入文章内容', trigger: 'blur' }],
        category: [{ required: true, message: '请选择文章分类', trigger: 'change' }],
        status: [{ required: true, message: '请选择发布状态', trigger: 'change' }]
      }
    };
  },
  computed: {
    isEdit() {
      return this.data && this.data.id;
    },
    uploadUrl() {
      return 'https://app.homeliftbuy.com/api/upload';
    },
    uploadHeaders() {
      return {
        Authorization: localStorage.getItem('token')
      };
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetForm();
      }
    },
    data: {
      handler(val) {
        if (val) {
          this.form = { ...val };
        }
      },
      immediate: true
    }
  },
  methods: {
    resetForm() {
      if (this.data) {
        this.form = { ...this.data };
      } else {
        this.form = {
          title: '',
          content: '',
          category: '',
          tags: '',
          cover: '',
          brief: '',
          status: 'draft'
        };
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    async onSubmit() {
      try {
        await this.$refs.form.validate();
        this.submitting = true;
        
        const url = this.isEdit ? `/api/admin/article/${this.data.id}` : '/api/admin/article';
        const method = this.isEdit ? 'put' : 'post';
        
        await axios[method](url, this.form, {
          headers: { Authorization: localStorage.getItem('token') }
        });
        
        this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
        this.$emit('update:visible', false);
        this.$emit('refresh');
      } catch (error) {
        if (error.response) {
          this.$message.error(error.response.data.message || '操作失败');
        }
      } finally {
        this.submitting = false;
      }
    },
    // 上传前检查
    beforeUpload(file) {
      const isImage = file.type.indexOf('image/') === 0;
      const isLt16M = file.size / 1024 / 1024 < 16;
      
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt16M) {
        this.$message.error('上传图片大小不能超过 16MB!');
        return false;
      }
      
      this.uploading = true;
      return true;
    },
    // 上传成功
    handleUploadSuccess(response) {
      this.uploading = false;
      if (response.code === 0) {
        this.form.cover = response.data.url;
        this.$message.success('图片上传成功!');
      } else {
        this.$message.error(response.msg || '上传失败');
      }
    },
    // 上传失败
    handleUploadError() {
      this.uploading = false;
      this.$message.error('图片上传失败!');
    },
    // 删除封面图片
    removeCover() {
      this.form.cover = '';
    },
    // 获取图片URL
    getImageUrl(url) {
      if (url.startsWith('http')) {
        return url;
      }
      return `https://app.homeliftbuy.com${url}`;
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.image-preview {
  position: relative;
  display: inline-block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}

.image-preview img {
  width: 200px;
  height: 120px;
  object-fit: cover;
  display: block;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  opacity: 0;
  transition: opacity 0.3s;
}

.image-preview:hover .image-overlay {
  opacity: 1;
}

.upload-tip {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}

.upload-demo {
  display: inline-block;
}
</style>